(function () {
    if (typeof document !== 'undefined') {

        var events = [
            'constructor.color-module',
        ];
        events.forEach((eventName) => {
            document.addEventListener(eventName, (event) => {
                console.log('event listener in jb-nexus, for event name', eventName);
                switch (eventName) {
                    case 'constructor.color-module':
                        var module = event.data;
                        if (module.configuration) {
                            console.log('module configuration', module.configuration);
                            module.configuration = {
                                // mode: 'dynamic-dark', // set specifically,
                            };
                        }
                        break;

                    default:
                        break;
                }
                // if (event.data) {
                //     console.log(eventName, 'was triggered, containing event data', event, event.data);
                //     event.data = {test: '123'};
                // }
            });
        });
    }
})()